'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var React = require('react');
var Content_web_styles = require('./Content.web.styles.cjs');

/**
 * Modal Content component - contains the main body content of the modal
 */ const Content = ({ children, customCss, ...props })=>{
    const contentStyles = React.useMemo(()=>[
            Content_web_styles.content,
            customCss
        ], [
        customCss
    ]);
    return /*#__PURE__*/ jsxRuntime.jsx("div", {
        css: contentStyles,
        ...props,
        children: children
    });
};

exports.Content = Content;
//# sourceMappingURL=Content.web.cjs.map
